module.exports = "<div class=\"deck row col-xs-offset-2 col-xs-8\" *ngIf=\"sortedDeliverables$ | async as deliverables\">\n  <div *ngFor=\"let deliverable of deliverables; trackBy: trackByFn\">\n      <itpx-evaluation-multi-content-deliverable [initState]=\"deliverable\"></itpx-evaluation-multi-content-deliverable>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/workflow_new/evaluation-multi-content-deliverable-list/evaluation-multi-content-deliverable-list.component.html
// module id = 896
// module chunks = 0